import { Label } from '@cian/ui-kit';

import * as React from 'react';

export const AdLabel: React.FC = () => (
  <Label data-name="r-label" data-testid="r-label" color="text-inverted-default" background="accent-ghost-primary">
    Реклама
  </Label>
);
